<template>
<v-card class="panel" elevation="1">
    <div class="subscriptions">
        <div class="page-header" style="margin-top:-30px;">
            <div class="left">
                <h2 class="page-title">{{ $page.props.lang.page_title || "Measurements" }} </h2>
            </div>
            <div class="center">
                <v-row>
                     <v-col cols="12">
                        <v-select
                                class="pt-10"
                                v-model="selectedChart"
                                :items="items"
                                item-text="text"
                                item-value="value"
                                @change="chartSelect"
                                persistent-hint
                                return-object
                                dense
                                outlined
                                flat
                                :disabled="isDisabled"
                        ></v-select>
                     </v-col>
                </v-row>
            </div>
             <div class="right">
                <v-btn @click="addModal = true" color="primary" dark>
                    <v-icon small>mdi-plus</v-icon>
                    <span v-if="$vuetify.breakpoint.mdAndUp" class="ml-2">{{ $page.props.lang.addMeasurement || "Add measurement" }}</span>
                </v-btn>
            </div>
        </div>
        <v-dialog v-model="addModal" max-width="500px">
            <v-card>
                <div class="modal-header">
                    <h4 class="modal-headline">{{ $page.props.lang.addMeasurement || "Add measurement" }}</h4>
                    <div class="tools">
                        <v-tooltip bottom open-delay="500">
                        <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="customsModal = true" text icon v-bind="attrs" v-on="on">
                            <v-icon color="primary" style="padding-right:2px">mdi-cogs</v-icon>
                        </v-btn>
                         </template>
                          <span>{{$page.props.lang.add_custom_field || "Add custom field"}}</span>
                            </v-tooltip>
                        <v-btn icon @click="addModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <v-card-text>
                  <v-container>
                      <v-row>
                            <v-col cols="6">
                                <p class="custom-label">{{ $page.props.lang.date || 'Date' }}</p>
                                <v-menu
                                    v-model="startDatePicker"
                                    :close-on-content-click="false"
                                    :return-value.sync="today"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                            :value="newMeasurement.date | formatDate" :hide-details="!responseErrors.date"
                                            append-icon="mdi-menu-down" readonly v-bind="attrs" v-on="on" @click:append="startDatePicker = true"
                                            :error-messages="responseErrors.date" @focus="responseErrors.date=''"
                                            outlined dense solo flat>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker
                                        v-model="newMeasurement.date"
                                        :first-day-of-week="1" locale="en" no-title scrollable color="primary">
                                            <v-spacer></v-spacer>
                                            <v-btn color="regular" @click="startDatePicker = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                                            <v-btn color="primary" @click="startDatePicker = false">{{ $page.props.lang.ok || "Ok" }}</v-btn>
                                        </v-date-picker>
                                </v-menu>
                            </v-col>
                      </v-row>
                      <v-row>
                            <v-col cols="6">
                                <p class="custom-label">{{ $page.props.lang.weight || 'Weight(kg)' }}</p>
                                <v-text-field v-model="newMeasurement.weight"
                                 :error-messages="responseErrors.weight" :hide-details="!responseErrors.weight"
                                 @focus="responseErrors.weight=''" outlined dense></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <p class="custom-label">{{$page.props.lang.height || "Height(cm)"}}</p>
                                <v-text-field v-model="newMeasurement.height"
                                :error-messages="responseErrors.height" :hide-details="!responseErrors.height"
                                @focus="responseErrors.height=''" outlined dense></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <p class="custom-label">{{$page.props.lang.bmi || "BMI"}}
                                <v-tooltip top open-delay="300"><template v-slot:activator="{ on, attrs }">
                                <v-btn text color="blue" class="ml-1" x-small v-bind="attrs" v-on="on" @click="calculateBMI">{{ $page.props.lang.caluclate || "Calculate" }}</v-btn>
                                </template><span>{{ $page.props.lang.caluclate_bmi || "Click to calculate body mass index" }}</span></v-tooltip></p>
                                <v-text-field v-model="newMeasurement.bmi"
                                :error-messages="responseErrors.bmi" :hide-details="!responseErrors.bmi"
                                @focus="responseErrors.bmi=''" outlined dense></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <p class="custom-label">{{$page.props.lang.body_fat || "Body fat(%)"}}</p>
                                <v-text-field v-model="newMeasurement.body_fat"
                                :error-messages="responseErrors.body_fat" :hide-details="!responseErrors.body_fat"
                                @focus="responseErrors.body_fat=''" outlined dense></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <p class="custom-label">{{$page.props.lang.muscular_mass || "Muscular mass"}}</p>
                                <v-text-field v-model="newMeasurement.muscular_mass"
                                :error-messages="responseErrors.muscular_mass" :hide-details="!responseErrors.muscular_mass"
                                @focus="responseErrors.muscular_mass=''" outlined dense></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <p class="custom-label">{{$page.props.lang.bone_mass || "Bone mass"}}</p>
                                <v-text-field v-model="newMeasurement.bone_mass"
                                :error-messages="responseErrors.bone_mass" :hide-details="!responseErrors.bone_mass"
                                @focus="responseErrors.bone_mass=''" outlined dense></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <p class="custom-label">{{$page.props.lang.body_water || "Body water"}}</p>
                                <v-text-field v-model="newMeasurement.body_water"
                                :error-messages="responseErrors.body_water" :hide-details="!responseErrors.body_water"
                                @focus="responseErrors.body_water=''" outlined dense></v-text-field>
                            </v-col>
                            <v-col cols="6" v-for="(field, index) in customsData" :key="field.id">
                                <p class="custom-label">{{ field.label }}({{field.type}})</p>
                                <v-text-field v-model="field.value"
                                :error-messages="responseErrors['customs.'+index+'.value']" :hide-details="!responseErrors['customs.'+index+'.value']"
                                @focus="responseErrors['customs.'+index+'.value']=''"
                                :type="field.type" outlined dense></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <p class="custom-label">{{ $page.props.lang.note || 'Notes' }}</p>
                                <v-textarea v-model="newMeasurement.note" outlined dense rows="3" hide-details></v-textarea>
                            </v-col>
                      </v-row>
                      <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="regular" @click="addModal = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                          <v-btn color="primary" @click="add()" :loading="saving">{{ $page.props.lang.save || "Save" }}</v-btn>
                      </v-card-actions>
                  </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <CustomsModal v-if="customsModal"
            :modal="customsModal"
            :customs="customs"
            @close="customsModal = false"
            @addCustom="addCustom">
        </CustomsModal>
        <v-dialog v-model="editModal" max-width="500px">
            <v-card>
                <div class="modal-header">
                    <h4 class="modal-headline">{{ $page.props.lang.editMeasurement || "Edit measurement" }}</h4>
                    <div class="tools">
                          <v-tooltip bottom open-delay="500">
                        <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="customsModal = true" text icon v-bind="attrs" v-on="on">
                            <v-icon color="primary" style="padding-right:2px">mdi-cogs</v-icon>
                        </v-btn>
                         </template>
                          <span>{{$page.props.lang.add_custom_field || "Add custom field"}}</span>
                            </v-tooltip>
                        <v-btn icon @click="editModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <v-card-text>
                  <v-container>
                      <v-row>
                            <v-col cols="6">
                                <p class="custom-label">{{ $page.props.lang.date || 'Date' }}</p>
                                <v-menu
                                    v-model="editStartDatePicker"
                                    :close-on-content-click="false"
                                    :return-value.sync="today"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                            :value="currentMeasurement.date | formatDate" :hide-details="!responseErrors.date"
                                            append-icon="mdi-menu-down" readonly v-bind="attrs" v-on="on" @click:append="editStartDatePicker = true"
                                            :error-messages="responseErrors.date" @focus="responseErrors.date=''"
                                            outlined dense solo flat>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker
                                        v-model="currentMeasurement.date"
                                        :first-day-of-week="1" locale="en" no-title scrollable color="primary">
                                            <v-spacer></v-spacer>
                                            <v-btn color="regular" @click="editStartDatePicker = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                                            <v-btn color="primary" @click="editStartDatePicker = false">{{ $page.props.lang.ok || "Ok" }}</v-btn>
                                        </v-date-picker>
                                </v-menu>
                            </v-col>
                      </v-row>
                      <v-row>
                            <v-col cols="6">
                                <p class="custom-label">{{ $page.props.lang.weight || 'Weight(kg)' }}</p>
                                <v-text-field v-model="currentMeasurement.weight"
                                 :error-messages="responseErrors.weight" :hide-details="!responseErrors.weight"
                                 @focus="responseErrors.weight=''" outlined dense></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <p class="custom-label">{{$page.props.lang.height || "Height(cm)"}}</p>
                                <v-text-field v-model="currentMeasurement.height"
                                :error-messages="responseErrors.height" :hide-details="!responseErrors.height"
                                @focus="responseErrors.height=''" outlined dense></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <p class="custom-label">{{$page.props.lang.bmi || "BMI"}}
                                <v-tooltip top open-delay="300"><template v-slot:activator="{ on, attrs }">
                                <v-btn text color="blue" class="ml-1" x-small v-bind="attrs" v-on="on" @click="calculateCurrentBMI">{{ $page.props.lang.caluclate || "Calculate" }}</v-btn>
                                </template><span>{{ $page.props.lang.caluclate_bmi || "Click to calculate body mass index" }}</span></v-tooltip></p>
                                <v-text-field v-model="currentMeasurement.bmi"
                                :error-messages="responseErrors.bmi" :hide-details="!responseErrors.bmi"
                                @focus="responseErrors.bmi=''" outlined dense></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <p class="custom-label">{{$page.props.lang.body_fat || "Body fat(%)"}}</p>
                                <v-text-field v-model="currentMeasurement.body_fat"
                                :error-messages="responseErrors.body_fat" :hide-details="!responseErrors.body_fat"
                                @focus="responseErrors.body_fat=''" outlined dense></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <p class="custom-label">{{$page.props.lang.muscular_mass || "Muscular mass"}}</p>
                                <v-text-field v-model="currentMeasurement.muscular_mass"
                                :error-messages="responseErrors.muscular_mass" :hide-details="!responseErrors.muscular_mass"
                                @focus="responseErrors.muscular_mass=''" outlined dense></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <p class="custom-label">{{$page.props.lang.bone_mass || "Bone mass"}}</p>
                                <v-text-field v-model="currentMeasurement.bone_mass"
                                :error-messages="responseErrors.bone_mass" :hide-details="!responseErrors.bone_mass"
                                @focus="responseErrors.bone_mass=''" outlined dense></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <p class="custom-label">{{$page.props.lang.body_water || "Body water"}}</p>
                                <v-text-field v-model="currentMeasurement.body_water"
                                :error-messages="responseErrors.body_water" :hide-details="!responseErrors.body_water"
                                @focus="responseErrors.body_water=''" outlined dense></v-text-field>
                            </v-col>
                             <v-col cols="6" v-for="(custom, index) in currentMeasurement.customs" :key="custom.label">
                                <p class="custom-label">{{ custom.label }}</p>
                                <v-text-field v-model="custom.value"
                                 :error-messages="responseErrors['customs.'+index+'.value']" :hide-details="!responseErrors['customs.'+index+'.value']"
                                @focus="responseErrors['customs.'+index+'.value']=''"
                                :type="custom.type"
                                outlined dense></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <p class="custom-label">{{ $page.props.lang.note || 'Notes' }}</p>
                                <v-textarea v-model="currentMeasurement.note" outlined dense rows="3" hide-details></v-textarea>
                            </v-col>
                      </v-row>
                      <v-card-actions>
                          <v-btn @click="openDeleteModal(currentMeasurement.id)" :id="'delete' + currentMeasurement.id" icon elevation="3">
                            <v-icon>mdi-trash-can-outline</v-icon>
                            <v-tooltip :activator="'#delete'+ currentMeasurement.id" right open-delay="500">
                                <span>{{$page.props.lang.deleteMeasurement || "Delete Measurement"}}</span>
                            </v-tooltip>
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn color="regular" @click="editModal = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                          <v-btn color="primary" @click="update()">{{ $page.props.lang.save || "Save" }}</v-btn>
                      </v-card-actions>
                  </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-card-text>
            <vue-frappe v-if="measurements != 0"
                id="member_measurement_chart"
                :labels="chartLabelsSet"
                :height="300"
                :line-options="{dotSize: 6, regionFill: 1}"
                :tooltip-options="tooltipOptions"
                :colors="[$page.props.organization.themeOptions.primary]"
                :dataSets="this.currentDataSet">
            </vue-frappe>
            <v-card v-else class="mx-auto my-12" max-width="500" outlined>
                <v-card-text v-html="$page.props.lang.no_measurement_label || 'No added measurements.<br> To add new measurement, press <b>add measurement</b> button.'" class="text-center "></v-card-text>
            </v-card>
        </v-card-text>
        <v-simple-table
            v-if="measurements != 0"
            mobile-breakpoint="0"
            hide-default-footer
        >
            <template v-slot:default>
                <thead>
                    <tr>
                    <th class="text-left" v-for="header in measurementsHeaders" :key="header.text">{{ header.text }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in measurementsData" :key="item.id">
                        <td>{{ item.date | formatDate }}</td>
                        <td>{{ item.height }}</td>
                        <td>{{ item.weight }}</td>
                        <td>{{ item.bmi }}</td>
                        <td>{{ item.body_fat }}</td>
                        <td>{{ item.muscular_mass }}</td>
                        <td>{{ item.bone_mass }}</td>
                        <td>{{ item.body_water }}</td>
                        <td v-for="custom in item.customs" :key="custom.id">
                                {{ custom.value }}
                        </td>
                         <td>
                            <v-btn @click="openEditModal(item)" :id="'edit' + item.id" icon>
                                <v-icon>mdi-pencil</v-icon>
                                <v-tooltip :activator="'#edit'+ item.id" bottom open-delay="500">
                                    <span>{{$page.props.lang.edit || "Edit"}}</span>
                                </v-tooltip>
                            </v-btn>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
        <ConfirmModal
                :title="$page.props.lang.confirmModalTitle || 'Confirmation'"
                :description="$page.props.lang.delete_confirmation_description || 'If you click YES, the measurement will be permanently deleted. Are you sure?'"
                :open="deleteModal"
                @no="deleteModal = false"
                @yes="deleteMeasurement()"
                @close="deleteModal = false">
        </ConfirmModal>
        </div>
</v-card>
</template>

<style scoped>
.table_custom {
  border: 1px solid #e6e6e6;
  background-color: #FFFFFF;
  color: rgba(0, 0, 0, 0.87);
}
</style>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import MemberLayout from './Layouts/Default'
import ConfirmModal from '@/js/Components/ConfirmModal'
import CustomsModal from '@/js/Components/CustomsModal'
import EventBus from '@/js/eventbus'

export default{
    metaInfo(){
        return{
             title: this.$page.props.member.full_name + ' - ' + (this.$page.props.lang.page_title || "Measurements")
        }
    },
    name:"MemberMeasurements",
    components: {
        ConfirmModal,
        CustomsModal
    },

    layout: (h, page) => {
      return h(AppLayout, [
        h(MemberLayout, [page]),
      ])
    },
    props: {
       member: Object,
       measurements: Array,
       customs: Array
    },
    data(){
      return {
        customsData: this.customs,
        measurementsData: this.measurements,
        customsMeasurementsData: [],
        addModal: false,
        saving: false,
        startDatePicker: false,
        editStartDatePicker: false,
        responseErrors: {},
        customsModal: false,
        today : moment().format('YYYY-MM-DD'),
        measurementsHeaders: [
                {text: this.$page.props.lang.date || 'Date', value: 'date', align: 'start'},
                {text: this.$page.props.lang.height || 'Height', value: 'height', align:'left'},
                {text: this.$page.props.lang.weight || 'Weight', value: 'weight', align: 'left'},
                {text: this.$page.props.lang.bmi || 'BMI', value: 'bmi', align: 'left'},
                {text: this.$page.props.lang.body_fat || 'Body Fat', value: 'body_fat', align: 'left'},
                {text: this.$page.props.lang.muscular_mass || 'Muscular mass', value: 'muscular_mass', align: 'left'},
                {text: this.$page.props.lang.bone_mass || 'Bone Mass', value: 'bone_mass', align: 'left'},
                {text: this.$page.props.lang.body_water || 'Body Water', value: 'body_water', align: 'left'},
                {text: '', value: 'action', sortable: false, align: 'end'},
            ],
        newMeasurement:{
            date: moment().format('YYYY-MM-DD'),
            member_id: this.member.id,
            weight: null,
            height: null,
            bmi: null,
            body_fat: null,
            muscular_mass: null,
            bone_mass: null,
            body_water: null,
            note: ''
            },
            renderChart: false,
            tooltipOptions: {
                label: '',
                valuesOverPoints: 1,
                formatTooltipX: () => '',
                formatTooltipY: (d) => (d + '').toUpperCase()
            },
            chartMonth: '',
            tablePage: 1,
            tablePageCount: 0,
            itemsPerPage: 8,
            deleteModal: false,
            measureForDeleteId: null,
            editModal: false,
            currentMeasurement: {},
            sortBy:'date',
            sortDesc:true,
            weightChart: false,
            toggle_exclusive: 0,
            chartLabelsSet:[],
            chartDataSet:{},
            currentDataSet: [],
            selectedChart: {text: this.$page.props.lang.weight || 'Weight', value: 0} ,
            customsErrors: {},
            items: [
            { text: this.$page.props.lang.weight || 'Weight(kg)', value: 0},
            { text: this.$page.props.lang.height || 'Height(cm)', value: 1},
            { text: this.$page.props.lang.bmi || 'BMI', value: 2},
            { text: this.$page.props.lang.body_fat || 'Body fat(%)', value: 3},
            { text: this.$page.props.lang.muscular_mass || 'Muscle mass(%)', value: 4},
            { text: this.$page.props.lang.bone_mass || 'Bone mass(%)', value: 5},
            { text: this.$page.props.lang.body_water || 'Body water(%)',value: 6}
            ],
            customObjHeaders:{}

      }
    },
    mounted() {
        this.renderChart = true
    },

    computed: {
        isDisabled(){
            if(this.measurements == 0){
                return true;
            }
        }
    },

    created(){

        var data = this.measurementsData.map(item => {
                return item.weight
                });
                this.currentDataSet = [{
                    name: this.$page.props.lang.weight || "Weight(kg)",
                    chartType: 'line',
                    values: data
                }];
                this.chartLabelsSet = this.measurementsData.map(item => {
                    return moment(item.date).format('DD.MM.YYYY')
                })

                this.chartLabelsSet.sort();


        EventBus.$on('CUSTOM_MEASUREMENT_ADDED', (p) => {
            this.customsData.push(p);

            if(Object.keys(this.currentMeasurement).length !== 0){
                this.currentMeasurement.customs.push(p);
            }

        });

        EventBus.$on('CUSTOM_MEASUREMENT_DELETED', (p) => {
            this.customsData.splice(p['index'], 1);

             if(Object.keys(this.currentMeasurement).length !== 0){
                this.currentMeasurement.customs.splice(p['index'], 1);
            }
        });

        EventBus.$on('CUSTOM_MEASUREMENT_UPDATED', (p) => {
            this.customsData[p['index']] = p['custom'];

            if(Object.keys(this.currentMeasurement).length !== 0){
                this.currentMeasurement.customs[p['index']] = p['custom'];
            }
        });

        this.setUpTableHeaders();
        this.addCustomsToChart();


    },

    methods: {

        setUpTableHeaders(){

            this.customs.forEach(item => {
                const headersCount = this.measurementsHeaders.length;
                let customObjHeaders = {};

                customObjHeaders.text = item.label+'('+item.type+')';
                customObjHeaders.value = item.order_number.toString();
                customObjHeaders.align = 'left';
                customObjHeaders.sortable = 'false';

                return this.measurementsHeaders.splice(headersCount - 1, 0, customObjHeaders);
            });

        },

        addCustomsToChart(){

            this.customs.forEach(element => {

                const chartCount = this.items.length;
                const lastItem = this.items[chartCount - 1]['value'];
                let customMeasurementObj = {};
                customMeasurementObj.text = element.label+'('+element.type+')';
                customMeasurementObj.value = 'cust-'+element.id;

                return this.items.push(customMeasurementObj);

            });

        },

        chartSelect(){
            axios.get('/backoffice/members/getChartData/'+ this.selectedChart.value +'/'+ this.member.id)
                .then(response => {
                    if(response.data.status === "OK"){
                        this.chartLabelsSet = response.data.labels;
                        this.chartDataSet = response.data.chartData;
                        this.chartDataSet.name = this.selectedChart.text;
                        this.chartDataSet.chartType = 'line',
                        this.currentDataSet.splice(0, 1, this.chartDataSet);
                    }else{
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'error',
                                timeout: 5000
                            })
                    }
                });
        },

        openEditModal(item){
            this.responseErrors = {};
             axios.get('/backoffice/members/getMeasurement/'+ item.id)
                .then(response => {
                    if(response.data.status === "OK"){
                        this.editModal = true
                        this.currentMeasurement = response.data.measurement
                        this.currentMeasurement.member_id = this.member.id

                    }else{
                         EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'error',
                                timeout: 5000
                            })
                    }
                });
        },

        openDeleteModal(id){
            this.deleteModal = true
            this.measureForDeleteId = id
        },

        calculateBMI(){
            if(this.newMeasurement.height && this.newMeasurement.weight){
            return this.newMeasurement.bmi = ((this.newMeasurement.weight / this.newMeasurement.height / this.newMeasurement.height) * 10000).toFixed(2);
            }else{
                EventBus.$emit('SHOW_NOTIFICATION',{
                                message: this.$page.props.lang.calculate_bmi_error || 'Enter weight and height first!',
                                color: 'error',
                                timeout: 5000
                            })
            }
        },

        calculateCurrentBMI(){
            if(this.currentMeasurement.height && this.currentMeasurement.weight){
            return this.currentMeasurement.bmi = ((this.currentMeasurement.weight / this.currentMeasurement.height / this.currentMeasurement.height) * 10000).toFixed(2);
            }else{
                 EventBus.$emit('SHOW_NOTIFICATION',{
                                message: this.$page.props.lang.calculate_bmi_error || 'Enter weight and height first!',
                                color: 'error',
                                timeout: 5000
                            })
            }
        },

        add(){
            this.newMeasurement.customs = this.customsData.map(item =>{
                return {
                        id: item.id,
                        value: item.value,
                        label: item.label
                        }
            });
            this.saving = true;
            axios.post('/backoffice/members/addMeasurement', this.newMeasurement)
                .then(response => {
                    this.saving = false;
                    if (response.data.status==="OK") {

                        this.addModal = false
                        this.$inertia.visit('/backoffice/members/details/'+ this.member.id +'/measurements')
                         EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                    }
                })
                .catch(error => {
                    this.saving = false;
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
        },

        update(){
            this.currentMeasurement.customs = this.currentMeasurement.customs.map(item =>{
                return {
                        id: item.id,
                        value: item.value,
                        label: item.label
                        }
            });
            axios.post('/backoffice/members/updateMeasurement', this.currentMeasurement)
                .then(response => {
                    if (response.data.status==="OK") {
                        this.editModal = false
                        this.$inertia.visit('/backoffice/members/details/'+ this.member.id +'/measurements')
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                    }
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
        },

        deleteMeasurement(){
            axios.post('/backoffice/members/deleteMeasurement', {id: this.measureForDeleteId})
                .then(response => {
                    if (response.data.status==="OK") {
                       this.$inertia.visit('/backoffice/members/details/'+ this.member.id +'/measurements')
                       EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                    }
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
                this.deleteModal = false
        },
        addCustom(){

        }
    }

}

</script>
